import {ApplicationIds, IAppConfig} from 'ngx-heka-design-lib';


export const APP_CONFIGS: IAppConfig[] = [
  {
    appId: ApplicationIds.CUSTOMER_PORTAL,
    translationTitle: 'APPS.CUSTOMER_PORTAL.TITLE',
    isCurrentApp: false,
    order: 0,
    imgUrl: 'assets/images/heka-logo-symbols/hplus.svg',
  },
  {
    appId: ApplicationIds.HPLUS_SERVICE,
    translationTitle: 'APPS.SERVICE.TITLE',
    isCurrentApp: false,
    order: 1,
    imgUrl: 'assets/images/heka-logo-symbols/office.svg',
  },
  {
    appId: ApplicationIds.B2B_ONLINE,
    translationTitle: 'APPS.B2B_ONLINE.TITLE',
    isCurrentApp: false,
    order: 2,
    imgUrl: 'assets/images/heka-logo-symbols/b2b_online.svg',
  },
  {
    appId: ApplicationIds.OPERATOR,
    translationTitle: 'APPS.OPERATOR.TITLE',
    isCurrentApp: false,
    order: 3,
    imgUrl: 'assets/images/heka-logo-symbols/operator.svg',
  },
  {
    appId: ApplicationIds.ELECTRICITY_CALCULATION_TOOL,
    translationTitle: 'APPS.ELECTRICITY_CALCULATION_TOOL.TITLE',
    isCurrentApp: false,
    order: 4,
    imgUrl: 'assets/images/heka-logo-symbols/e_calc_tool.svg',
  },
  {
    appId: ApplicationIds.TENDER_TOOL,
    translationTitle: 'APPS.TENDER_TOOL.TITLE',
    isCurrentApp: false,
    order: 5,
    imgUrl: 'assets/images/heka-logo-symbols/tender_tool.svg',
  },
  {
    appId: ApplicationIds.LEVEL_2,
    translationTitle: 'APPS.LEVEL_2.TITLE',
    isCurrentApp: false,
    order: 6,
    imgUrl: 'assets/images/heka-logo-symbols/hplus.svg',
  },
  {
    appId: ApplicationIds.HPLUS_DONGLE,
    translationTitle: 'APPS.HPLUS_DONGLE.TITLE',
    isCurrentApp: false,
    order: 7,
    imgUrl: 'assets/images/heka-logo-symbols/dongle.svg',
  },
  {
    appId: ApplicationIds.HPLUS_DONGLE_ADMIN,
    translationTitle: 'APPS.HPLUS_DONGLE_ADMIN.TITLE',
    isCurrentApp: false,
    order: 8,
    imgUrl: 'assets/images/heka-logo-symbols/dongle_admin.svg',
  },
  {
    appId: ApplicationIds.REMOTE_ADMIN,
    translationTitle: 'APPS.REMOTE_ADMIN.TITLE',
    isCurrentApp: false,
    order: 9,
    imgUrl: 'assets/images/heka-logo-symbols/remote_desktop.svg',
  },
  {
    appId: ApplicationIds.REMOTE_DESKTOP,
    translationTitle: 'APPS.REMOTE_DESKTOP.TITLE',
    isCurrentApp: false,
    order: 10,
    imgUrl: 'assets/images/heka-logo-symbols/remote_desktop.svg',
  },
  {
    appId: ApplicationIds.OMS_TOOL,
    translationTitle: 'APPS.OMS_TOOL.TITLE',
    isCurrentApp: true,
    order: 11,
    imgUrl: 'assets/images/heka-logo-symbols/oms.svg',
  },
  {
    appId: ApplicationIds.STATUS,
    translationTitle: 'APPS.STATUS.TITLE',
    isCurrentApp: false,
    order: 12,
    imgUrl: 'assets/images/heka-logo-symbols/status.svg',
  },
  {
    appId: ApplicationIds.GO_APP_ADMIN,
    translationTitle: 'APPS.GO_APP_ADMIN.TITLE',
    isCurrentApp: false,
    order: 13,
    imgUrl: 'assets/images/heka-logo-symbols/go_app.svg',

  },
  {
    appId: ApplicationIds.LEARN_WORLD,
    translationTitle: 'APPS.LEARN_WORLD.TITLE',
    isCurrentApp: false,
    order: 14,
    imgUrl: 'assets/images/heka-logo-symbols/learn_world.svg',
  },
  {
    appId: ApplicationIds.AI_PLAN,
    translationTitle: 'APPS.AI_PLAN.TITLE',
    isCurrentApp: false,
    order: 15,
    imgUrl: 'assets/images/heka-logo-symbols/ai_plan.svg',
  }
];
